import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import bulkImage from "../../assets/images/Bulk Pickup Made Easy section image Final PNG.png";
import work2Image from "../../assets/images/Sell Used Appliances  file_Doorstep Pickup copy.png";
import work1Image from "../../assets/images/Sell Used Appliances  file_Get the best offer copy.png";
import whySelsmartImage from "../../assets/images/why choose us JPEG (2).jpg";
import work3Image from "../../assets/images/Sell Used Appliances  file_Instant Payment copy 2.png";
import groceryImage from "../../assets/images/icons why choose us_As Easy as Grocery Shopping copy.svg";
import fastestImage from "../../assets/images/icons why choose us_Fastest Pickup copy.svg";
import secureImage from "../../assets/images/icons why choose us_Secure Transactions copy.svg";
import transparentPricingImage from "../../assets/images/icons why choose us_Transparent Pricing copy.svg";
import trustImage from "../../assets/images/icons why choose us_Trusted Across India copy.svg";

import OwlCarouselComponent from "../../components/common/OwlCarouselComponent";
import TestimonialSlider from "../../components/common/TestimonialSlider";
import "../../components/common/common.css";
import MediaPartners from "../../components/common/media";
import JourneySection from "../../components/common/ourJOurneySection";
import "../../components/common/responsive.css";
import "../../components/common/style.css";
import Feedbacks from "../../components/common/testimonialsPage";
import { useCart } from "../../contexts/cartContext";
import { useUser } from "../../contexts/userContext";
import { useApi } from "../../shared/api";
import type { Iappliance, Ibanner, IhomeContent } from '../../types';
import "./homePage.css";
// const ReactTickerAny: any = ReactTicker;
import { FaqsOnly } from "../../components/Faqs/FAQS";
import eventBus from "../../components/common/eventBus";
import { useDispatch, useSelector } from "react-redux";
import { selectUtmCampaign, setUtmId } from "../../redux/slices/utm";
import VoucherOwlCarouselComponent from "../../components/common/voucherCarousal";

interface IMetaData {
  result: {
    page_title: string;
    meta_description: string;
    meta_tag: string;
    cronical_url: string
  }
}

function generateUtmSessionId(length = 24) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
}

const changeTitleAndMetaTags = async (
  title: string,
  metaTags: { description?: string; keywords?: string;[key: string]: string | undefined }
) => {
  try {
    // Update the document title

    if (title) {
      document.title = title;
    } else {
      document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
    }

    // Update or create meta tags
    Object.keys(metaTags).forEach((metaName) => {
      if (metaName === 'cronical_url') return;
      const metaTag = document.querySelector(`meta[name="${metaName}"]`);
      if (metaTag) {
        // Update existing meta tag
        metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
      } else {
        // Create new meta tag if it doesn't exist
        const newMetaTag = document.createElement('meta');
        newMetaTag.name = metaName;
        newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
        document.head.appendChild(newMetaTag);
      }
    });

    if (metaTags.cronical_url) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute('href', metaTags.cronical_url);
      } else {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        canonicalLink.setAttribute('href', metaTags.cronical_url);
        document.head.appendChild(canonicalLink);
      }
    }

    // Cleanup function to reset the title and meta tags when unmounting
    return () => {
      document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
      Object.keys(metaTags).forEach((metaName) => {
        if (metaName === 'cronical_url') return;
        const metaTag = document.querySelector(`meta[name="${metaName}"]`);
        if (metaTag) {
          metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
        }
      });

      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute('href', window.location.href);
      }
    };
  } catch (error) {
    //console.error("Error updating title and meta tags:", error);
  }
};

const setChangeTitleAndMetaTags = async (data: IMetaData) => {
  try {
    await changeTitleAndMetaTags(data.result?.page_title, { description: data.result?.meta_description, keywords: data.result?.meta_tag, cronical_url: window.location.href });
  } catch (error) {
    console.error(error)
  }
}


const modalStyles: { overlay: React.CSSProperties; modal: React.CSSProperties; button: React.CSSProperties } = {
  overlay: {
    position: 'fixed', // Valid string for 'position'
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  button: {
    padding: '5px',
    margin: '8px',
  }
};


const HomePage = () => {
  const [feedbackList, setFeedbackList] = useState<any[]>([]);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [mobileNo, setMobileNo] = useState('');
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [expandedFaqId, setExpandedFaqId] = useState<number | null>(null);
  const [seoContent, setSeoContent] = useState<string | null>(null);
  const [tickerContent, setTickerContent] = useState<IhomeContent | null>(null);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [banners, setBanners] = useState<Ibanner[]>([]);
  const [popupMsg, setPopupMsg] = useState("");
  const [loadingg, setLoadingg] = useState(true);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch()
  // const [imageLoadingStates, setImageLoadingStates] = useState<{ [key: number]: boolean }>(
  //   {}
  // );
  const [imageLoadingStates, setImageLoadingStates] = useState<{ [key: number]: boolean }>({});

  const [heavyAppliances, setHeavyAppliances] = useState<Iappliance[]>([])
  const [lightAppliances, setLightAppliances] = useState<Iappliance[]>([])
  const [electricAppliances, setElectricAppliances] = useState<Iappliance[]>([])
  const [vouchers, setVouchers] = useState([]);
  const loc = useLocation();
  const API = useApi();

  const {
    checkSessionTokenExpirationStatus,
    handleRemoveLocalStorage,
    globalUtmQueryRef,
    setGlobalSearchTerm,
    setUtmSessionId,
    fetchCsrfToken,
    city_name,
    city_pincode
  } = useUser();
  const { handleQuantity } = useCart();
  const utm_query = useSelector(selectUtmCampaign)
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get("ref_code");

  if (refCode) {
    sessionStorage.setItem("setReferralCode", refCode);
  }

  const handleBulkPickups = () => {
    navigate('/bulk-pickup');
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  const query = new URLSearchParams(loc.search);
  const utmQuery = loc.state?.utmQuery;
  let utmQueryRef: any = useRef("")


  const handleFaqs = () => {
    setGlobalSearchTerm("");
    window.open('/faq', '_blank');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const handleImageLoad = (index: number) => {
    setImageLoadingStates((prevStates) => ({
      ...prevStates,
      [index]: false,
    }));
  };

  const handleImageError = (index: number) => {
    setImageLoadingStates((prevStates) => ({
      ...prevStates,
      [index]: false,
    }));
  };

  const fetchSeoMetaDetails = async () => {
    const code = 'home_page'
    return API.API_V1.getSeoMetaDetails(code);
  };

  const fetchTicker = () => {
    const ticker_code = 'home_page_ticker'
    return API.API_V1.getHomeContent(ticker_code)
  }

  const getHomePageBanner = () => {
    return API.API_V1.getHomePageBanner()
  }

  const getHeavyAppliances = () => {
    return API.API_V1.getHeavyAppliances();
  }

  const getLightAppliances = () => {
    return API.API_V1.getLightAppliances();
  }

  const getElectricAppliances = () => {
    return API.API_V1.getElectricAppliances()
  }

  const getAllVouchers = () => {
    return API.API_V1.voucher.getAllVouchers()
  }

  const getHomePageBannerWithQuery = () => {
    return API.API_V1.getHomePageBannerWithQuery(city_name)
  }

  useEffect(() => {
    // Initial banner load
    const loadBanner = async () => {
      try {
        const bannerRes = await getHomePageBannerWithQuery(); // Assuming city-specific banners
        setBanners(bannerRes.data);
      } catch (error) {
        console.error('Error fetching initial banner:', error);
      }
    };

    loadBanner();

    // Handle event from Header
    const handler = async () => {
      try {
        const bannerRes = await getHomePageBannerWithQuery(); // Or getHomePageBanner()
        setBanners(bannerRes.data);
      } catch (error) {
        console.error('Error updating banner after header change:', error);
      }
    };

    eventBus.on('headerChanged', handler);

    return () => {
      eventBus.off('headerChanged', handler);
    };
  }, [city_name]); // if city_name affects banners



  const fetchAllData = async () => {
    try {
      // fetchTickerData
      const [metaData, banner, heavyAppliances, lightAppliances, electricAppliances, tickerData, city_banner, vouchers] = await Promise.all([fetchSeoMetaDetails(), getHomePageBanner(), getHeavyAppliances(), getLightAppliances(), getElectricAppliances(), fetchTicker(), getHomePageBannerWithQuery(), getAllVouchers()]);
      setBanners(city_banner.data)
      setChangeTitleAndMetaTags(metaData.data)
      setHeavyAppliances(heavyAppliances?.data?.appliances || []);
      setLightAppliances(lightAppliances?.data?.appliances || []);
      setElectricAppliances(electricAppliances?.data?.appliances || [])
      setTickerContent(tickerData)
      setVouchers(vouchers.data)
      // setBanners(banner.data)

    } catch (error) {
      console.error('promise error', error)
    }

  }
  useEffect(() => {
    sessionStorage.removeItem("mobileNumber");
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem('categoryId');
    fetchAllData()
    checkUtm(query, setUtmSessionId, globalUtmQueryRef, createUtmTrackingSaveService, utmQueryRef, utmQuery)


    const wrapper = wrapperRef.current;
    fetchSEOContent()
    if (!wrapper) return;

    // Duplicate content for seamless rotation
    wrapper.innerHTML += wrapper.innerHTML;

    let scrollPosition = 0; // Tracks the current scroll position
    const originalWidth = wrapper.scrollWidth / 2; // Half the total width (original content)

    const moveTicker = () => {
      if (!wrapper) return;

      scrollPosition += 1; // Move 1px to the left
      if (scrollPosition >= originalWidth) {
        scrollPosition = 0; // Reset to start for seamless loop
      }

      wrapper.style.transform = `translateX(-${scrollPosition}px)`;
      requestAnimationFrame(moveTicker); // Recursively call for smooth movement
    };

    requestAnimationFrame(moveTicker); // Start the ticker animation

    return () => {
      // Cleanup when the component is unmounted
      wrapper.style.transform = `translateX(0px)`;
    };
  }, [loc]);


  const checkUtm = (query: any, setUtmSessionId: any, globalUtmQueryRef: any, createUtmTrackingSaveService: any, utmQueryRef: any, utmQuery: any) => {

    const utmSource = query.get('utm_source');
    const newUtmCampaign = query.get("utm_campaign");
    const oldUtmCampaign = utm_query
      ? getUtmCampaignFromString(utm_query)
      : null;

    if (utm_query == null || !utm_query || newUtmCampaign !== oldUtmCampaign) {
      if (utmSource) {

        const utmSessionId = generateUtmSessionId(); // Simple session ID generator

        setUtmSessionId(utmSessionId);
        const fullCampaignUrl = window.location.href.replace(/&/g, ":<>:");
        let utmquerydata = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
          /&/g,
          ":<>:"
        )}`;
        utmQueryRef.current =
          globalUtmQueryRef.current = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
            /&/g,
            ":<>:"
          )}`;
        localStorage.setItem(
          "utm_query_data",
          `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
            /&/g,
            ":<>:"
          )}`
        );

        dispatch(setUtmId(utmquerydata));

        if (newUtmCampaign !== oldUtmCampaign) {

          createUtmTrackingSaveService(utmquerydata);
        }

        //   dispatch(setUtmId(utmquerydata))
        //   if(utmquerydata.utm_compaign !== utm_query.utm_campiagn ){
        // createUtmTrackingSaveService(utmquerydata);
        //   }

      } else {
        if (utmQuery) {

          utmQueryRef.current = utmQuery;
          globalUtmQueryRef.current = utmQuery;
          createUtmTrackingSaveService(utmQuery);
        }
      }
    }

  }

  const getUtmCampaignFromString = (utm: string) => {
    const params = new URLSearchParams(utm.replace(/:<>:/g, "&"));
    return params.get("utm_campaign");
  };

  const createUtmTrackingSaveService = async (utmData: any) => {
    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const ip_address = ipData.ip;
      const updatedUtmData = new URLSearchParams(utmData);
      const response = await fetch(
        `${backendUrl}${version}utm-campaign-tracking?${updatedUtmData.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          mode: "cors"
        }
      );
    } catch (err: any) {
      setError(err.message);
    } finally {
    }
  }

  const fetchSEOContent = async () => {
    try {
      const response = await fetch(`${backendUrl}${version}seo-content/home_page_seo`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"
        });
      const data = await response.json();
      setSeoContent(data.data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem('categoryId');
    sessionStorage.removeItem('productId');

    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get("ref_code");

    if (refCode) {
      sessionStorage.setItem("setReferralCode", refCode);
    }
  }, []);


  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
    if (isSessionHandled) return;

    if (checkSessionTokenExpirationStatus()) {
      handleQuantity();
      handleRemoveLocalStorage();
      sessionStorage.setItem("sessionHandled", "true");
      navigate("/");
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '');
    setMobileNo(value);
    setShowError(value.length > 0 && value.length < 10);

    if (error) {
      setError(null);
    }
  };

  const handleSubscribe = async () => {
    if (mobileNo.length !== 10) {
      setError('Mobile number must be 10 digits long.');
      return;
    }

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ mobile_no: mobileNo }),

      });

      if (response.ok) {
        const data = await response.json();

        setShowModalInfo(true)
        setPopupMsg(data.result)

      } else {

      }
    } catch (error) {
      //console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  const handleCloseModalClick = () => {
    setError("");
    setMobileNo('')
    setShowModalInfo(false);

  };

  return (

    <div className='home-page'>

      <main className="main-content">
        <section>
          <div className="scroll">
          </div>
        </section>

        {tickerContent ? (
          <div className="ticker-container">
            <div className="container">
              <div className="ticker-wrapper" ref={wrapperRef}>
                <div
                  className="ticker-text"
                  dangerouslySetInnerHTML={{ __html: tickerContent.data }}
                />
                <div
                  className="ticker-text"
                  dangerouslySetInnerHTML={{ __html: tickerContent.data }}
                />
                <div
                  className="ticker-text"
                  dangerouslySetInnerHTML={{ __html: tickerContent.data }}
                />
                <div
                  className="ticker-text"
                  dangerouslySetInnerHTML={{ __html: tickerContent.data }}
                />
                <div
                  className="ticker-text"
                  dangerouslySetInnerHTML={{ __html: tickerContent.data }}
                />
                <div
                  className="ticker-text"
                  dangerouslySetInnerHTML={{ __html: tickerContent.data }}
                />
              </div>
            </div>
          </div>
        ) : null}

        {/* Banner */}


        <section className={`slide_banner skeleton-banner animated-skeleton`}>
          <div className="container-fluid p-0">
            <div className="row">

              <div
                id="carouselExampleCaptions"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-touch="true"
              >
                <div className="carousel-indicators">
                  {banners.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target="#carouselExampleCaptions"
                      data-bs-slide-to={index}
                      className={index === 0 ? "active" : ""}
                      aria-current={index === 0 ? "true" : undefined}
                      aria-label={`Slide ${index + 1}`}
                    ></button>
                  ))}
                </div>

                <div className="p-0">
                  {banners.map((banner, index) => (
                    <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                      <div className="row banner_wrap">
                        <div className="col-12 image_slide justify-content-center d-flex">
                          {/* Optional loader animation for each image */}
                          {/* {imageLoadingStates[index] !== false && (
                      <div className="loaderr-container">
                        <div className="loaderr"></div>
                      </div>
                    )} */}

                    {/* Web Image */}
                    <img
                      
                      src={banner.img_url}
                      className="web_img d-block w-100" width="1920" height="430"
                      alt="banner"
                      style={{ maxWidth:"100%", height:"auto",
                        display: imageLoadingStates[index] === false ? "block" : "none",
                      }}
                      onLoad={() => handleImageLoad(index)}
                      onError={() => handleImageError(index)}
                      onClick={() =>
                        banner.link_url && window.open(banner.link_url, "_blank")
                      }
                    />

                    {/* Mobile Image */}
                    <img
                      
                      src={banner.mobile_img_url}
                      className="mob_img d-block w-100" width="576" height="430"
                      alt="banner"
                      style={{ maxWidth:"100%", height:"auto",
                        display: imageLoadingStates[index] === false ? "block" : "none",
                      }}
                      onLoad={() => handleImageLoad(index)}
                      onError={() => handleImageError(index)}
                      onClick={() =>
                        banner.link_url && window.open(banner.link_url, "_blank")
                      }
                    />
                  </div>
                </div>
              </div>
  ))}
  </div>
  </div>
  </div>
  </div>

        </section>

        {/* appliances list */}
        <OwlCarouselComponent heading="Sell Large Appliances" data={heavyAppliances} />
        <OwlCarouselComponent heading="Sell Small Appliances" data={lightAppliances} />
        <OwlCarouselComponent heading="Sell Electronics and Gadgets" data={electricAppliances} />

        <VoucherOwlCarouselComponent heading="🎁 Earn more with vouchers" data={vouchers} />

        <section className="howWorks">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="featuredProduct">
                  <h2 className="headingText">
                    Sell Used Electronics in 3 Simple Steps
                  </h2>
                  <h5 className="topText">
                    India’s largest online platform for selling used electronics
                  </h5>
                </div>
                <div className="workCard row ">
                  <div className=" col col1">
                    <div className="works col-12">
                      <img src="/images/Sell Used Appliances  file_Get the best offer copy.png" width="122" height="122" style={{maxWidth:"100%", height:"auto"}} alt="" loading="lazy" />
                      <h3 className="workHeading">Get the Best Offer</h3>
                      <p className="workText">
                        Find out your product's value in just a few clicks
                      </p>
                    </div>
                  </div>
                  <div className=" col col2">
                    <div className="works col-12">
                      <img src="/images/Sell Used Appliances  file_Doorstep Pickup copy.png" width="122" height="122" style={{maxWidth:"100%", height:"auto"}} alt="" loading="lazy" />
                      <h3 className="workHeading">Doorstep Pickup</h3>
                      <p className="workText">
                        Schedule now, and we’ll pick up your product within
                        24-48 hours
                      </p>
                    </div>
                  </div>
                  <div className=" col col3">
                    <div className="works col-12">
                      <img src="/images/Sell Used Appliances  file_Instant Payment copy 2.png " width="122" height="122" style={{maxWidth:"100%", height:"auto"}} alt="" loading="lazy" />
                      <h3 className="workHeading">Instant Payment</h3>
                      <p className="workText">
                        Receive your payment online immediately
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <OurPartners /> */}
        <TestimonialSlider />

        <section className="eco-friendly">
          <div className="container">
            <div className="eco-right">
              <div className="whyChoose text-center">
                <h2 className="headingText">Why Choose Selsmart?</h2>
                <h5 className="topText">
                  Eco-Friendly Recycling by India’s largest E-waste Recycler
                </h5>
              </div>
              <div className="eco-info">
                <div className="whyselsmart col-10 d-flex mx-auto align-items-center">
                  <div className="eco-left col-6">
                    <img
                      loading="lazy"
                      src={whySelsmartImage} width="445" height="486" style={{maxWidth:"100%", height:"auto"}}
                      alt="Product Image"
                      className="eco-img"
                    />
                  </div>
                  <div className="eco-items col-6">
                    <div className="eco-item">
                      <img src={transparentPricingImage} alt="Heart Icon" loading="lazy" />
                      <div className="eco-text">
                        <h3>Transparent Pricing</h3>
                        <p>No hidden charges—what you see is what you get</p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={groceryImage} alt="Heart Icon" loading="lazy" />
                      <div className="eco-text">
                        <h3>As Easy as Grocery Shopping</h3>
                        <p>
                          Experience a simple way to sell your used electronics
                        </p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={fastestImage} alt="Recycle Icon" loading="lazy" />
                      <div className="eco-text">
                        <h3>Fastest Pickup</h3>
                        <p>
                          Get your old appliance picked up within 24-48 hours
                        </p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={secureImage} alt="Recycle Icon" loading="lazy" />
                      <div className="eco-text">
                        <h3>Secure Transactions</h3>
                        <p>Payments are processed securely and reliably</p>
                      </div>
                    </div>
                    <div className="eco-item">
                      <img src={trustImage} alt="Recycle Icon" loading="lazy" />
                      <div className="eco-text">
                        <h3>Trusted Across India</h3>
                        <p>
                          Serving customers nationwide with reliability and satisfaction
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <JourneySection />

        <Feedbacks />

        <section className="bulk-pickup">
          <div className="container">
            <div className="col-md-10 col-lg-10 mx-auto">
              <div className="row">
                <div className="col-md-6 col-lg-6 pickup">
                  <h2 className="pickupHeading">Bulk Pickup Made Easy</h2>
                  <p className="pickupContent">
                    Partner with Selsmart for efficient bulk appliance pickups
                    that simplify responsible recycling.
                  </p>
                  <p className="pickupContent">
                    Housing Societies | Institutions | Offices
                  </p>
                  <button className="bulkPickupBtn" onClick={handleBulkPickups}>
                    Bulk Pickup Request
                  </button>
                </div>
                <div className="col-md-6 col-lg-6  pickupImg">
                  <img src={bulkImage} alt="bulkpickup" width="456" height="409" style={{maxWidth:"100%", height:"auto"}} loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="faqs-homepage">
          <div className="text-center faqHome">
            <h2 className="headingTextFaq">FAQs</h2>
          </div>

          {/* Render FAQs without heading */}
          <FaqsOnly limit={5} showContactButton={true} showHeading={false} />

          <div className="col-12 text-center">
            <a className="v_all d-inline-block" onClick={handleFaqs}>
              View All
            </a>
          </div>
        </section>

        <MediaPartners />

        <section className="bulk-pickup Subscribe_news_letter ">
          <div className="container">
            <div className="col-md-10 col-lg-10 mx-auto">
              <h2 className="pickupHeading text-center">
                Stay Updated With Selsmart
              </h2>
              <div className="row">
                <div className=" col-md-12 col-lg-8 pickup text-center mx-auto">
                  <p className="pickupContent">
                    Sign up for free to receive updates, tips, and the latest offers from Selsmart via WhatsApp!

                  </p>

                  <p className="pickupContent">
                    Rest assured; we won’t spam you with messages :)
                  </p>
                  <div className="subscribe-container">
                    <div className="newsletter">
                      <input
                        type="text"
                        className="subscribe-input"
                        placeholder="Enter your number"
                        aria-label="Mobile Number"
                        value={mobileNo}
                        maxLength={10}
                        onChange={handleChange} // Call your handleChange function here
                      />


                      <button className="subscribe-button" onClick={handleSubscribe} > <i className="fab fa-whatsapp" style={{ fontSize: '24px', color: '#fff' }}></i>
                      </button>

                    </div>
                    {error && <p className="error-message">{error}</p>}
                    {showError && <p className="error-message-home">10 digits required</p>}
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>

        {showModalInfo && (
          <div className='popup_cart' style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
              {/* <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} /> */}
              <p className="cart-empty-msg">{popupMsg}</p>
              <button className="cart-empty-button" onClick={handleCloseModalClick}>Got it</button>
            </div>
          </div>

        )}

        <div className="container">
          <div className='seo-content'>{seoContent}</div>
        </div>
      </main>
    </div>

  );
};

export default HomePage;
